const domaine = 'UTILISATEUR'

export const ENREGISTRER_UTILISATEUR = `${domaine}/ENREGISTRER_UTILISATEUR`
export const SUPPRIMER_UTILISATEUR = `${domaine}/SUPPRIMER_UTILISATEUR`
export const UPDATE_CGU = `${domaine}/UPDATE_CGU`